"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledModalFooter = exports.StyledModalBody = exports.StyledModalHeader = exports.StyledModalContent = exports.StyledModalWrapper = exports.StyledModalLightbox = exports.StyledModalTrigger = exports.StyledModal = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
exports.StyledModal = styled_components_1.default.div({
    height: '100vh',
    left: '0px',
    position: 'fixed',
    top: '0px',
    width: '100%'
}, function (_a) {
    var zIndex = _a.zIndex;
    return ({
        zIndex: zIndex
    });
});
exports.StyledModalTrigger = styled_components_1.default.div({
    display: 'inline-flex'
});
var lighboxAnimIn = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var blockAnimIn = styled_components_1.keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  0% {\n    transform: scaleX(0.8) scaleY(0.8)\n  }\n  100% {\n    transform: scaleX(1) scaleY(1)\n  }\n"], ["\n  0% {\n    transform: scaleX(0.8) scaleY(0.8)\n  }\n  100% {\n    transform: scaleX(1) scaleY(1)\n  }\n"])));
exports.StyledModalLightbox = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  animation: ", " 0.2s linear;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  animation: ", " 0.2s linear;\n  background-color: ", ";\n"])), lighboxAnimIn, theme_1.colors.lightbox);
exports.StyledModalWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: ", ";\n  animation: ", " 0.13s ease-out;\n  width: calc(100% - ", ");\n  height: calc(100% - ", ");\n  overflow-y: auto;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: ", ";\n  animation: ", " 0.13s ease-out;\n  width: calc(100% - ", ");\n  height: calc(100% - ", ");\n  overflow-y: auto;\n"])), theme_1.scaffolding.md, blockAnimIn, theme_1.scaffolding.xl, theme_1.scaffolding.xl);
exports.StyledModalContent = styled_components_1.default.div({
    backgroundColor: theme_1.colors.white,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: '100%'
}, function (_a) {
    var isFluid = _a.isFluid;
    return ({
        maxWidth: isFluid ? '100%' : theme_1.breakpoints.sm
    });
});
exports.StyledModalHeader = styled_components_1.default.div({
    alignItems: 'center',
    borderBottom: "1px solid " + theme_1.colors.grey3,
    display: 'flex',
    h4: __assign(__assign({}, theme_1.font), { fontSize: '19px', fontWeight: theme_1.fontWeights.bold, lineHeigt: '27px', margin: '0px' }),
    justifyContent: 'space-between',
    padding: theme_1.scaffolding.md
});
exports.StyledModalBody = styled_components_1.default.div({
    overflowY: 'auto',
    padding: theme_1.scaffolding.md
});
exports.StyledModalFooter = styled_components_1.default.div({
    borderTop: "1px solid " + theme_1.colors.grey3,
    padding: theme_1.scaffolding.md
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styles.js.map